import { useLang } from "hooks/useLang"
import SARCurrency from "./SarCurrency"

const SAR = ({
    price,
    width = 13,
    height = 13,
    color = "white",
    textSize = 14,
}: {
    price?: number | string
    width?: number
    height?: number
    color?: string
    textSize?: number
}) => {
    const { lang, t } = useLang()

    // Check if price is 0 or "0"
    const numericPrice = typeof price === "string" ? parseFloat(price) : price
    const isFree = numericPrice === 0

    return (
        <span
            className={`flex gap-1 flex-${lang === "ar" ? "row-reverse" : "row"} items-center justify-center`}
        >
            {!isFree && (
                <div className="flex items-center justify-center">
                    <SARCurrency width={width} height={height} fill={color} />
                </div>
            )}

            <span className={`text-[${textSize}px]`}>
                {isFree ? t("free") : price}
            </span>
        </span>
    )
}
export default SAR
